export const FILTER_FIELD_SX = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    bgcolor: "#fafbfc",
    fontSize: "0.875rem",
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.875rem",
  },
};

export const HEADER_TOOLBAR_SX = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 1.25,
  rowGap: 1.25,
};

export const HEADER_PAPER_SX = {
  px: { xs: 1.5, sm: 2 },
  py: 1.25,
  bgcolor: "#fff",
  border: "1px solid #e5e9ef",
  borderRadius: "12px",
  boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
};

export const HEADER_ICON_BUTTON_SX = {
  width: 36,
  height: 36,
  flexShrink: 0,
  border: "1px solid #e5e9ef",
  borderRadius: "8px",
  bgcolor: "#fafbfc",
};
